import React, { useState, useEffect } from 'react';
import {
  TextInput,
  Field,
  Fieldset,
  Button,
  Select,
  Typeahead,
  TypeaheadItem,
  TypeaheadItemSuggestion,
  SearchIcon,
  Radio,
  CheckIcon,
  FieldBody,
  Alert,
  FieldLabel
} from '@emorg-prd/react-standard';
import './index.css';
import Site from '../../../../api/Site';
import PrimaryUseType from '../../../../api/PrimaryUseType';
import OperationStatus from '../../../../api/OperationStatus';
import SourceSystem from '../../../../api/SourceSystem';
import SourceSystemIdType from '../../../../api/SourceSystemIdType';
import ITSiteCode from '../../../../api/ITSiteCode';
import ProgressTabNavigator from '../ProgressTabNavigator';
import { SourceSystemValidationService as SourceSystemValidation } from '../../../../services/sourceSystemValidationService';

function LocationSite(props) {
  let {
    locationName,
    country,
    siteId,
    siteName,
    siteCode,
    siteCountryId,
    siteOperationStatus,
    sitePrimaryUseType,
    itSiteCodeList,
    siteSourceLinkList,
    onChange,
    handlePageError,
    onNavigateForward,
    onNavigateBackward,
    onSetProgressTabComplete,
    toggleNewExisting
  } = props;
  const [siteList, setSiteList] = useState([]);
  const [itSiteCodeDropdown, setITSiteCodeDropdown] = useState([]);
  const [siteOperationStatusDropdown, setSiteOperationStatusDropdown] = useState([]);
  const [siteSourceSystemNameDropdown, setSiteSourceSystemNameDropdown] = useState([]);
  const [siteSourceSystemTypeDropdown, setSiteSourceSystemTypeDropdown] = useState([]);
  const [primaryUseTypeDropdown, setPrimaryUseTypeDropdown] = useState([]);

  useEffect(() => {
    var isLoading = true;
    window.scrollTo(0, 0);
    Site.getAll().then((res) => {
      if (isLoading) {
        setSiteList(res
          .filter(x => x.country?.countryId === country.id)
          .sort((a, b) => { return a.siteName.localeCompare(b.siteName) })
        );
      }
    }).catch((error) => {
      handlePageError(error.message);
    });
    PrimaryUseType.getAll().then((res) => {
      primaryUseTypeDataFilter(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    OperationStatus.getAll().then((res) => {
      if (isLoading) {
        res.sort((a, b) => a.displayOrder - b.displayOrder);
        setSiteOperationStatusDropdown(res);
      }
    }).catch((error) => {
      handlePageError(error.message);
    });
    ITSiteCode.getAll().then((res) => {
      if (isLoading) {
        res.sort((a, b) => {
          return a.itSiteCode.localeCompare(b.itSiteCode);
        });
        setITSiteCodeDropdown(res);
      }
    }).catch((error) => {
      handlePageError(error.message);
    });
    SourceSystem.GetSiteSourceSystems().then((res) => {
      if (isLoading) {
        res.sort((a, b) => {
          return a.sourceSystemName.localeCompare(b.sourceSystemName);
        });
        setSiteSourceSystemNameDropdown(res);
      }
    }).catch((error) => {
      handlePageError(error.message);
    });
    SourceSystemIdType.getAll().then((res) => {
      if (isLoading) {
        res.sort((a, b) => {
          return a.sourceSystemIdTypeName.localeCompare(b.sourceSystemIdTypeName);
        });
        setSiteSourceSystemTypeDropdown(res);
      }
    }).catch((error) => {
      handlePageError(error.message);
    });

    if (toggleNewExisting === undefined) {
      onChange('toggleNewExisting', 'existing');
      onChange('siteName', siteName);
    }

    onSetProgressTabComplete();
  }, []);

  const primaryUseTypeDataFilter = (primaryUseTypes) => {
    let primaryUseTypeOptions = primaryUseTypes.filter((primaryUse) => {
      if (primaryUse.isAssignable.trim().toLowerCase() === 's') {
        return primaryUse;
      } else {
        return null;
      }
    });
    setPrimaryUseTypeDropdown(primaryUseTypeOptions);
  };

  const renderOperationStatusDropdown = (operationStatus) => {
    return (
      <option
        key={operationStatus.operationStatusId}
        id={operationStatus.operationStatusId}
        value={operationStatus.operationStatusName}
        hidden={!operationStatus.isActive}
      >
        {operationStatus.operationStatusName}
      </option>
    );
  };
  const renderITSiteCodeDropdown = (itSiteCode) => {
    return (
      <option
        id={itSiteCode.itSiteCodeId}
        key={itSiteCode.itSiteCodeId}
        value={itSiteCode.itSiteCode}
      >
        {itSiteCode.itSiteCode}: {itSiteCode.itSiteCodeDesc}
      </option>
    );
  };
  const renderSourceSystemDropdown = (sourceSystem) => {
    return (
      <option
        key={sourceSystem.sourceSystemId}
        id={sourceSystem.sourceSystemId}
        value={sourceSystem.sourceSystemName}
        hidden={!sourceSystem.sourceSystemIsActive}
      >
        {sourceSystem.sourceSystemName}
      </option>
    );
  };
  const renderSourceSystemTypeDropdown = (sourceSystemIdType) => {
    return (
      <option
        key={sourceSystemIdType.sourceSystemIdTypeId}
        id={sourceSystemIdType.sourceSystemIdTypeId}
        value={sourceSystemIdType.sourceSystemIdTypeName}
        hidden={!sourceSystemIdType.sourceSystemIdTypeIsActive}
      >
        {sourceSystemIdType.sourceSystemIdTypeName}
      </option>
    );
  };

  const handleITSiteCodeSelect = (index, event) => {
    const values = [...itSiteCodeList];
    values[parseInt(index)].itSiteCode = event.target.value;
    values[parseInt(index)].itSiteCodeId = event.target.options[event.target.selectedIndex].id;

    onChange('itSiteCodeList', values);
  };

  const addITSiteCode = () => {
    const values = [...itSiteCodeList];
    values.push({
      itSiteCodeId: '',
      itSiteCode: '',
      itSiteCodeDesc: '',
      //siteId: selectedSite,
    });
    onChange('itSiteCodeList', values);
  };

  const addSourceSystem = () => {
    const values = [...siteSourceLinkList];
    values.push({
      sourceSystemId: '',
      sourceSystemName: '',
      sourceSystemIdTypeId: '',
      sourceSystemIdTypeName: '',
      sourceSystemReferenceId: '',
      sourceSystemIsActive: true,
      sourceSystemIdTypeIsActive: true,
      isSourceSystemValid: false,
      isLoading: false,
      validationErrorMessage: ''
    });
    onChange('siteSourceLinkList', values);
  };

  const removeITSiteCodeField = (index) => {
    const values = [...itSiteCodeList];
    values.splice(index, 1);
    onChange('itSiteCodeList', values);
  };

  const removeSourceSystem = (index) => {
    const values = [...siteSourceLinkList];
    values.splice(index, 1);
    onChange('siteSourceLinkList', values);
  };

  async function validateSourceSystemReferenceId(index) {
    let sourceSystemLinkListCopy = [...siteSourceLinkList];
    let sourceSystemLink = sourceSystemLinkListCopy[parseInt(index)];

    sourceSystemLink.validationErrorMessage = '';
    sourceSystemLink.isLoading = true;
    onChange('siteSourceLinkList', sourceSystemLinkListCopy);

    sourceSystemLink = await SourceSystemValidation.validateSiteSourceSystem(sourceSystemLink);

    onChange('siteSourceLinkList', sourceSystemLinkListCopy);
  }

  const handleSourceSystemChange = (input, index, event) => {
    let siteSourceLinkCopy = [...siteSourceLinkList];
    let siteSourceObject = siteSourceLinkCopy[parseInt(index)];
    switch (input) {
      case 'name':
        siteSourceObject.sourceSystemName = event.target.value;
        siteSourceObject.sourceSystemId = event.target.options[event.target.selectedIndex].id;
        siteSourceObject.sourceSystemIdTypeId = '';
        siteSourceObject.sourceSystemIdTypeName = '';
        siteSourceObject.sourceSystemReferenceId = '';
        break;
      case 'type':
        siteSourceObject.sourceSystemIdTypeName = event.target.value;
        siteSourceObject.sourceSystemIdTypeId = event.target.options[event.target.selectedIndex].id;
        siteSourceObject.isSourceSystemValid = SourceSystemValidation.isNoValidationSourceSystem(siteSourceObject);
        break;
      case 'reference':
        if (
          SourceSystemValidation.isOriginalSourceSystem(event.target.value, siteSourceObject)
          || SourceSystemValidation.isNoValidationSourceSystem(siteSourceObject)
        ) {
          siteSourceObject.isSourceSystemValid = true;
        }
        else {
          siteSourceObject.isSourceSystemValid = false;
        }
        siteSourceObject.sourceSystemReferenceId = event.target.value;
        break;
      default:
        alert('error');
    }
    onChange('siteSourceLinkList', siteSourceLinkCopy);
  };

  const handleSiteChange = (e, value = null) => {
    e.target.click();
    if (e.key === 'Enter') {
      e.preventDefault();
    }
    onChange('siteName', e.target.value);
    value ? populateSiteValues(value) : populateSiteValues(e.target.value);
  };

  const populateSiteValues = (value) => {
    clearFormValues();
    onChange('siteName', value);
    const currentSiteObj = siteList.find((site) => site.siteName === value);
    if (value && currentSiteObj) {
      const currentOpStatus = siteOperationStatusDropdown.find(
        (opStatus) => opStatus.operationStatusId === currentSiteObj.operationStatusId
      );
      if (currentSiteObj.primaryUseTypeId) {
        const currentPrimaryUseType = primaryUseTypeDropdown.find(
          (primaryUse) => primaryUse.primaryUseTypeId === currentSiteObj.primaryUseTypeId
        );
        onChange('sitePrimaryUseType', currentPrimaryUseType.primaryUseTypeName);
        onChange('sitePrimaryUseTypeId', currentPrimaryUseType.primaryUseTypeId);
      }

      if (currentSiteObj.itSiteCodeRelate.length) {
        currentSiteObj.itSiteCodeRelate.forEach((element, index) => {
          let elementValue = {
            itSiteCodeId: element.itSiteCodeId,
            itSiteCode: element.itSiteCode?.itSiteCode,
            itSiteCodeDesc: element.itSiteCode?.itSiteCodeDesc,
          };
          itSiteCodeList.push(elementValue);
        });
      }
      if (currentSiteObj.siteSourceSystemRelate.length) {
        currentSiteObj.siteSourceSystemRelate.forEach((element, index) => {
          let elementSourceSystem = {};
          elementSourceSystem.siteId = element.siteId;
          elementSourceSystem.siteSourceSystemId = element.siteSourceSystemId;
          elementSourceSystem.sourceSystemName = element.sourceSystem?.sourceSystemName;
          elementSourceSystem.sourceSystemIsActive = element.sourceSystem?.isActive.toLowerCase() === 'y' ? true : false;
          elementSourceSystem.sourceSystemId = element.sourceSystem?.sourceSystemId;
          elementSourceSystem.sourceSystemIdTypeName = element.sourceSystemIdType?.sourceSystemIdTypeName;
          elementSourceSystem.sourceSystemIdTypeIsActive = element.sourceSystemIdType?.isActive;
          elementSourceSystem.sourceSystemIdTypeId = element.sourceSystemIdTypeId;
          elementSourceSystem.originalSourceSystemIdTypeId = element.sourceSystemIdTypeId;
          elementSourceSystem.sourceSystemReferenceId = element.sourceSystemReferenceId;
          elementSourceSystem.originalSourceSystemReferenceId = element.sourceSystemReferenceId;
          elementSourceSystem.isSourceSystemValid = true;
          elementSourceSystem.isLoading = false;
          elementSourceSystem.validationErrorMessage = '';
          siteSourceLinkList.push(elementSourceSystem);
        });
      }
      onChange('siteId', currentSiteObj.siteId);
      onChange('siteCode', currentSiteObj.siteCode);
      onChange('siteCountryId', currentSiteObj.country?.countryId);
      onChange('siteOperationStatus', currentOpStatus.operationStatusName);
      onChange('siteOperationStatusId', currentOpStatus.operationStatusId);
    }
  };

  const handleSiteToggle = (event, value) => {
    event.preventDefault();
    onChange('toggleNewExisting', value);
    onChange('siteName', value === 'new' ? locationName : '');
    clearFormValues(value);
  };

  const clearFormValues = (toggleValue) => {
    onChange('siteId', '');
    onChange('siteCode', '');
    onChange('siteOperationStatus', '');
    onChange('siteOperationStatusId', '');
    onChange('sitePrimaryUseTypeId', '');
    onChange('sitePrimaryUseType', '');
    itSiteCodeList.splice(0, itSiteCodeList.length);
    siteSourceLinkList.splice(0, siteSourceLinkList.length);
  };

  return (
    <div className='page'>
      <div className='input-row'>
        <Radio
          style={{
            paddingTop: '30px',
            paddingLeft: '5px',
            border: 0,
            background: 'transparent',
          }}
          id='primary-interest'
          value={'new'}
          label='Create New Site'
          onClick={(e) => handleSiteToggle(e, 'new')}
          checked={toggleNewExisting === 'new'}
        />
        <Radio
          style={{
            paddingTop: '30px',
            paddingLeft: '5px',
            border: 0,
            background: 'transparent',
          }}
          id='primary-interest'
          value={'existing'}
          label='Select Existing Site'
          onClick={(e) => handleSiteToggle(e, 'existing')}
          checked={toggleNewExisting === 'existing'}
        />
      </div>
      <Fieldset>
        {toggleNewExisting === 'existing' ? (
          <Field>
            <FieldLabel>Site Name</FieldLabel>
            <FieldBody>
              <form className='em-c-search-form'>
                <div className='em-c-search__body'>
                  <Typeahead
                    className='site-search'
                    onChange={(e, value) => handleSiteChange(e, value)}
                    error={!siteId || country.id !== siteCountryId}
                    inputProps={{
                      className: 'site-search-bar',
                      onChange: (e) => handleSiteChange(e),
                      onKeyPress: (e) => handleSiteChange(e),
                      value: siteName,
                      placeholder: 'Search Sites',
                      error: !siteId || country.id !== siteCountryId,
                    }}
                  >
                    {siteList
                      .filter(
                        (site) =>
                          site.siteName.toLowerCase()
                            .slice(0, siteName.trim().toLowerCase().length)
                          === siteName.trim().toLowerCase()
                      )
                      .map((site) => (
                        <TypeaheadItem id={site.siteId} value={site.siteName}>
                          <TypeaheadItemSuggestion>
                            <span>{`${site.siteName}`}</span>
                          </TypeaheadItemSuggestion>
                        </TypeaheadItem>
                      ))}
                  </Typeahead>
                  <Button className='location-site-secondary'>
                    <SearchIcon size='small' />
                  </Button>
                </div>
              </form>
            </FieldBody>
          </Field>
        ) : (
          <TextInput
            className='site-input'
            label='Site Name *'
            value={siteName}
            note={
              siteName.length < 5
                ? 'Mininium length of 5 characters'
                : siteName.length > 50
                  ? 'Maximum length of 50 characters'
                  : ''
            }
            onChange={(e) => onChange('siteName', e.target.value)}
            error={
              (siteName.length < 5 || siteName.length > 50) &&
              toggleNewExisting !== 'existing'
            }
          />
        )}

        <TextInput
          className='site-country-input'
          label='Site Country'          
          placeholder=''
          value={country.name}
          error={toggleNewExisting === 'existing' && country.id !== siteCountryId}
          note={
            !(country.id)
              ? 'Please select a Country in Step 1'
              : toggleNewExisting === 'existing' && country.id !== siteCountryId
                ? 'Site Name must correspond to selected country'
                : ''
          }
          readOnly
        />

        {toggleNewExisting === 'new' ? (
          <div>
            <TextInput
              className='site-input'
              label='Site Code *'
              placeholder=''
              value={siteCode}
              onChange={(e) => onChange('siteCode', e.target.value)}
              error={
                siteCode.length < 1 ||
                (siteCode.length > 20 && toggleNewExisting !== 'existing')
              }
              note={
                siteCode.length > 20
                ? 'Maximum length of 20 characters'
                : ''
              }
            />

            <Select
              selectProps={{
                style: { width: '615px' },
              }}
              label='Primary Use *'
              value={sitePrimaryUseType}
              onChange={(e) => {
                onChange('sitePrimaryUseType', e.target.value);
                onChange(
                  'sitePrimaryUseTypeId',
                  e.target.options[e.target.selectedIndex].id
                );
              }}
              error={sitePrimaryUseType.length <= 0 && toggleNewExisting !== 'existing'}
            >
              <option value=''>Select</option>
              {primaryUseTypeDropdown.map((primaryUse) => {
                return (
                  <option
                    key={primaryUse.primaryUseTypeId}
                    id={primaryUse.primaryUseTypeId}
                    value={primaryUse.primaryUseTypeName}
                    hidden={!primaryUse.isActive}
                  >
                    {primaryUse.primaryUseTypeName}
                  </option>
                );
              })}
            </Select>
            <Select
              selectProps={{
                style: { width: '615px' },
              }}
              label='Operation Status *'
              value={siteOperationStatus}
              onChange={(e) => {
                onChange('siteOperationStatus', e.target.value);
                onChange(
                  'siteOperationStatusId',
                  e.target.options[e.target.selectedIndex].id
                );
              }}
              error={siteOperationStatus.length <= 0 && toggleNewExisting !== 'existing'}
            >
              <option value=''>Select</option>
              {siteOperationStatusDropdown.map(renderOperationStatusDropdown)}
            </Select>
          </div>
        ) : (
          <div>
            <TextInput
              className='site-input'
              label='Site Code'
              readOnly={toggleNewExisting === 'existing'}
              placeholder=''
              value={siteCode}
              onChange={(e) => onChange('siteCode', e.target.value)}
            />

            <TextInput
              className='site-input'
              label='Primary Use'
              readOnly={toggleNewExisting === 'existing'}
              placeholder=''
              value={sitePrimaryUseType}
              onChange={(e) => onChange('sitePrimaryUseType', e.target.value)}
            />

            <TextInput
              className='site-input'
              label='Operation Status'
              readOnly={toggleNewExisting === 'existing'}
              placeholder=''
              value={siteOperationStatus}
              onChange={(e) => onChange('siteOperationStatus', e.target.value)}
            />
          </div>
        )}
      </Fieldset>

      <Fieldset>
        {itSiteCodeList.map((siteCode, index) => (
          <div key={`${siteCode}~${index}`} className='input-row'>
            <Select
              selectProps={{
                className: 'site-dynamic-field',
              }}
              label='IT Site Code'
              value={siteCode.itSiteCode}
              error={!siteCode.itSiteCodeId}
              onChange={(e) => handleITSiteCodeSelect(index, e)}
              disabled={toggleNewExisting === 'existing'}
            >
              <option value=''>Select</option>
              {itSiteCodeDropdown.map(renderITSiteCodeDropdown)}
            </Select>
            <Button
              style={{ paddingTop: '50px', paddingLeft: '30px' }}
              className='small-margin'
              variant='tertiary'
              size='small'
              disabled={toggleNewExisting === 'existing'}
              onClick={() => removeITSiteCodeField(index)}
            >
              × Remove IT Site Code
            </Button>
          </div>
        ))}
        <Button
          className='small-margin'
          variant='tertiary'
          size='small'
          style={{ paddingTop: '-10px', paddingLeft: '15px' }}
          onClick={addITSiteCode}
          disabled={toggleNewExisting === 'existing'}
        >
          + Add IT Site Code
        </Button>
      </Fieldset>

      <Fieldset>
        {siteSourceLinkList.map((siteSourceSystemLink, index) => (
          <div key={`${siteSourceSystemLink}~${index}`}>
            <Alert
              variant='error'
              style={{
                marginBottom: '15px',
                display:
                siteSourceSystemLink.validationErrorMessage != ''
                  ? 'flex' : 'none',
              }}
            >
              {siteSourceSystemLink.validationErrorMessage}
            </Alert>
            <div className='input-row'>
              <Select
                selectProps={{
                  className: 'site-dynamic-field',
                }}
                label='Site Source System'
                disabled={!siteSourceSystemLink.sourceSystemIsActive}
                value={siteSourceSystemLink.sourceSystemName}
                error={!siteSourceSystemLink.sourceSystemId}
                onChange={(e) => handleSourceSystemChange('name', index, e)}
              >
                <option value=''>Select</option>
                {siteSourceSystemNameDropdown.map(renderSourceSystemDropdown)}
              </Select>
              <Select
                selectProps={{
                  className: 'site-dynamic-field',
                }}
                style={{ paddingLeft: '15px' }}
                label='Source System Type'
                disabled={!siteSourceSystemLink.sourceSystemIsActive}
                value={siteSourceSystemLink.sourceSystemIdTypeName}
                error={!siteSourceSystemLink.sourceSystemIdTypeName}
                onChange={(e) => handleSourceSystemChange('type', index, e)}
              >
                <option value=''>Select</option>
                {siteSourceSystemTypeDropdown
                  .filter((type) =>
                    type.sourceSystemId == siteSourceSystemLink.sourceSystemId
                  )
                  .map(renderSourceSystemTypeDropdown)}
              </Select>

              <form className='-em-c-search-form'>
                <div className='em-c-search__body'>
                  <TextInput
                    label='Source System Reference Id'
                    disabled={!siteSourceSystemLink.sourceSystemIsActive}
                    placeholder=''
                    style={{ paddingLeft: '15px', width: '300px' }}
                    value={siteSourceSystemLink.sourceSystemReferenceId}
                    error={
                      siteSourceSystemLink.sourceSystemReferenceId === '' ||
                      !siteSourceSystemLink.isSourceSystemValid
                    }
                    onChange={(e) => handleSourceSystemChange('reference', index, e)}
                  />
                  <Button
                    style={{
                      display:
                        siteSourceSystemLink.sourceSystemIdTypeName &&
                        siteSourceSystemLink.sourceSystemReferenceId &&
                        !SourceSystemValidation.isNoValidationSourceSystem(siteSourceSystemLink) &&
                        !siteSourceSystemLink.isLoading &&
                        siteSourceSystemLink.sourceSystemIsActive
                          ? 'block' : 'none'
                    }}
                    className={
                      !siteSourceSystemLink.isSourceSystemValid
                        ? 'small-margin validation-button red-outline'
                        : 'small-margin validation-button grey-outline'
                    }
                    variant='secondary'
                    size='medium'
                    error={
                      siteSourceSystemLink.sourceSystemIdTypeName &&
                      !siteSourceSystemLink.isSourceSystemValid
                    }
                    onClick={(e) => {
                      if (
                        siteSourceSystemLink.sourceSystemIdTypeId &&
                        siteSourceSystemLink.sourceSystemReferenceId &&
                        siteSourceSystemLink.sourceSystemName
                      ) {
                        validateSourceSystemReferenceId(
                          index,
                          country.id
                        )
                      }}
                    }
                  >
                    {siteSourceSystemLink.isSourceSystemValid ? '' : 'Validate'}
                    <CheckIcon
                      style={{
                        display:
                          siteSourceSystemLink.isSourceSystemValid ? 'block' : 'none'
                      }}
                    />
                  </Button>
                  <Button
                    style={{
                      display:
                        siteSourceSystemLink.sourceSystemIdTypeName &&
                        siteSourceSystemLink.isLoading
                          ? 'block' : 'none',
                    }}
                    className='small-margin validation-button'
                    loading
                    size='medium'
                  >
                    Loading
                  </Button>
                </div>
              </form>
              <Button
                className='small-margin'
                variant='tertiary'
                size='small'
                style={{ paddingTop: '50px', paddingLeft: '30px' }}
                onClick={() => removeSourceSystem(index)}
              >
                × Remove Site Source Link
              </Button>
            </div>
          </div>
        ))}
        <Button
          className='small-margin'
          variant='tertiary'
          size='small'
          style={{ paddingTop: '-10px', paddingLeft: '15px' }}
          onClick={addSourceSystem}
        >
          + Add Site Source Link
        </Button>
      </Fieldset>

      <ProgressTabNavigator
        onNavigateBackward={onNavigateBackward}
        onNavigateForward={onNavigateForward}
      > 
      </ProgressTabNavigator>
    </div>
  );
}

export default LocationSite;
